import { useState } from "react";
import "../../assets/css/AddedCss.css";
import { UpdateMasterServer } from "../../services/apiUtils";
import { Modal, notification, Switch } from "antd";
import PropTypes from "prop-types";

const UserDetailEdit = ({ editTemple, setEditModal, setEditTemple }) => {
  console.log("editData", editTemple);

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!editTemple.Name) newErrors.Name = "Name is required";
    if (!editTemple.City) newErrors.City = "City is required";
    if (!editTemple.Village) newErrors.Village = "Village is required";
    if (!editTemple.Location) newErrors.Location = "Location is required";

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditTemple((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const newErrors = { ...errors };

    if (!value) {
      newErrors[name] =
        name.charAt(0).toUpperCase() +
        name.slice(1).replace(/_/g, " ") +
        " is required";
    } else {
      newErrors[name] = "";
    }

    setErrors(newErrors);
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length !== 0) {
      notification.error({
        message: "Error",
        description: "Fill correct data for Master update...",
      });
      return;
    }

    const trimmedTempleData = {
      MasterId: editTemple.MasterId,
      City: editTemple.City,
      Village: editTemple.Village,
      Location: editTemple.Location,
      Name: editTemple.Name,
      state: editTemple.state,
      country: editTemple.country,
      Status: editTemple.Status,
      Type: editTemple.Type,
      ID: editTemple.ID,
    };

    try {
      await UpdateMasterServer(trimmedTempleData);
      notification.success({
        message: "Success",
        description: "Master updated complete...",
      });
      setEditModal(false);
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Master update failed...",
      });
    }
  };

  return (
    <Modal
      open={true}
      title={
        <div className="d-flex align-items-center gap-2">
          <h5 className="modal-title mb-0">Edit Master</h5>
        </div>
      }
      onCancel={() => {
        setEditModal(false);
      }}
      onOk={handleSubmit}
      okText="Save changes"
      cancelText="Close"
      destroyOnClose
      centered
    >
      {editTemple && (
        <form>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              name="Name"
              className={`form-control ${errors.Name ? "is-invalid" : ""}`}
              value={editTemple.Name}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.Name && (
              <div className="invalid-feedback">{errors.Name}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">City</label>
            <input
              type="text"
              name="City"
              className={`form-control ${errors.City ? "is-invalid" : ""}`}
              value={editTemple.City}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.City && (
              <div className="invalid-feedback">{errors.City}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Village</label>
            <input
              type="text"
              name="Village"
              className={`form-control ${errors.Village ? "is-invalid" : ""}`}
              value={editTemple.Village}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.Village && (
              <div className="invalid-feedback">{errors.Village}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Location</label>
            <input
              type="text"
              name="Location"
              className={`form-control ${errors.Location ? "is-invalid" : ""}`}
              value={editTemple.Location}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.Location && (
              <div className="invalid-feedback">{errors.Location}</div>
            )}
          </div>

          <div className="d-flex align-items-center gap-3 mt-2">
            <Switch
              checked={editTemple.Status === 1}
              checkedChildren="ON"
              unCheckedChildren="OFF"
              onChange={(checked) =>
                setEditTemple({
                  ...editTemple,
                  Status: checked ? 1 : 0,
                })
              }
            />
          </div>
        </form>
      )}
    </Modal>
  );
};

export default UserDetailEdit;

UserDetailEdit.propTypes = {
  editTemple: PropTypes.shape({
    Name: PropTypes.string.isRequired,
    MasterId: PropTypes.string.isRequired,
    ID: PropTypes.number.isRequired,
    City: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    Location: PropTypes.string.isRequired,
    latitude: PropTypes.string.isRequired,
    Village: PropTypes.string.isRequired,
    Type: PropTypes.string.isRequired,
    Status: PropTypes.number.isRequired,
  }).isRequired,
  setEditModal: PropTypes.func.isRequired,
  setEditTemple: PropTypes.func.isRequired,
  setHideContent: PropTypes.func.isRequired,
};
